namespace GeniuzPOS.Lookups {
    export namespace VwPosStationService {
        export const baseUrl = 'Lookups/VwPosStation';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwPosStationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwPosStationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwPosStation/Retrieve",
            List = "Lookups/VwPosStation/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwPosStationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
